/**
 * Utilidades para manejar deprecación de props
 */

/**
 * Muestra un warning de deprecación cuando se usan props legacy
 *
 * @param propName - Nombre de la prop deprecada
 * @param alternative - Prop alternativa recomendada
 */
export const warnDeprecated = (propName: string, alternative: string) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(
      `[InnerButton] La prop "${propName}" está deprecada y será removida en una versión futura. ` +
        `Por favor, usa "${alternative}" en su lugar. `,
    );
  }
};

/**
 * Igual que el aviso deprecado, pero listando solo las props que realmente se están usando
 * en este render (no un grupo genérico).
 *
 * @param deprecatedPropsUsed - Nombres de props deprecadas presentes (p. ej. `['colorIcon', 'onClickIcon']`)
 * @param alternative - API recomendada (ej. `iconProps`, `badge`)
 */
export const warnDeprecatedPropList = (
  deprecatedPropsUsed: readonly string[],
  alternative: string,
  /** Por defecto InnerButton; usa `[Modal]` u otro prefijo en otros módulos. */
  componentTag: string = '[InnerButton]',
) => {
  if (process.env.NODE_ENV === 'production' || deprecatedPropsUsed.length === 0) {
    return;
  }
  const unique = [...new Set(deprecatedPropsUsed)];
  const joined = unique.map((p) => `"${p}"`).join(', ');
  const singular = unique.length === 1;
  // eslint-disable-next-line no-console
  console.warn(
    `${componentTag} ${singular ? 'La prop' : 'Las props'} ${joined} ${singular ? 'está deprecada' : 'están deprecadas'} y ${singular ? 'será' : 'serán'} eliminada${singular ? '' : 's'} en una versión futura. ` +
      `Usa \`${alternative}\` en su lugar.`,
  );
};
